import request from '@/utils/request'
import qs from 'qs'
export function getListRevenueWeekly(query) {
  return request({
    url: '/report-service/v1/revenue-report/week',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
export function getListRevenueWeeklyExcel(query) {
  return request({
    url: '/report-service/v1/revenue-report/week/excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    },
    responseType: 'blob'
  })
}
